import { useModal } from "@/Contexts";
import { useGlobalAlert } from "@/States/globalAlert";
import { trpc } from "@/Utils/trpc";
import { useNavigate } from "@/Utils/useNavigate";
import { useTerminals } from "@/api/hooks/useTerminals";
import ModalContainer from "@/components/modalContainer";
import { useEmailJob } from "@/pages/configuration/components/useEmailJob";

import { useMemo, useState } from "react";
import { useForm } from "react-hook-form";

import { isEmpty } from "lodash";
import { EmailJobType } from "server/config-api/index.js";

import { BuildingForm, BuildingFormData } from "./BuildingForm";

export const CreateBuildingModal = () => {
  const { hideModal } = useModal();
  const navigate = useNavigate();
  const { refetchTerminals, isLoadingTerminals } = useTerminals();
  const { addEmailJob } = useEmailJob();
  const { setGlobalAlert } = useGlobalAlert();
  const [isSubmitAttempted, setIsSubmitAttempted] = useState(false);

  const formHandler = useForm<BuildingFormData>({});

  const {
    formState: { errors, isValid, isDirty },
    handleSubmit,
  } = formHandler;

  const { mutate, isPending: isSaving } = trpc.terminals.create.useMutation({
    onSuccess: async (terminal) => {
      const terminalId = terminal.id;
      const contactEmail = terminal.operations.email;
      await addEmailJob({
        terminalId,
        email: contactEmail,
        type: EmailJobType.ActionReport,
      });
      await refetchTerminals();

      setGlobalAlert({
        type: "success",
        message: "systemMessages:terminalAdded",
      });
      hideModal();
      navigate(`/infrastructure/manage/${terminalId}`);
    },
  });

  const isLoading = isSaving || isLoadingTerminals;

  const setupBuilding = (formData: BuildingFormData) => {
    const terminalData = {
      name: formData.name,
      status: "ACTIVE",
      category: formData.category,
      contactEmail: formData.contactEmail,
      area: formData.area,
      street: formData.street,
      postalCode: formData.postalCode,
      postalRegion: formData.postalRegion,
      country: formData.country,
      coordinates: formData.coordinates,
    };

    mutate(terminalData);
  };

  const onSubmit = handleSubmit((formData) => {
    setIsSubmitAttempted(true);
    setupBuilding(formData);
  });

  const isSubmitDisabled = useMemo(
    () => isSubmitAttempted && (!isEmpty(errors) || !isValid),
    [isSubmitAttempted, errors, isValid],
  );

  return (
    <ModalContainer
      title="actions:createTerminal"
      onConfirm={() => onSubmit()}
      onConfirmLoading={isLoading}
      onCancel={hideModal}
      onConfirmDisabled={isSubmitDisabled}
      className="w-3/4 sm:w-1/2 lg:w-1/3"
      showDiscardModal={isDirty}
    >
      <BuildingForm formHandler={formHandler} />
    </ModalContainer>
  );
};
